import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CoSelfcheckCheckoutPage } from './co-selfcheck-checkout';
import { PipesModule } from '../../pipes/pipes.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { DirectivesModule } from '../../directives/directives.module';
import { ComponentsModule } from '../../components/components.module';
import { CoSelfcheckAccountPageModule } from '../co-selfcheck-account/co-selfcheck-account.module';

@NgModule({
  declarations: [
    CoSelfcheckCheckoutPage,
  ],
  imports: [
    IonicPageModule.forChild(CoSelfcheckCheckoutPage),
    PipesModule,
    NgxPaginationModule,
    DirectivesModule,
    ComponentsModule,
    CoSelfcheckAccountPageModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class CoSelfcheckCheckoutPageModule {}



// WEBPACK FOOTER //
// ./src/pages/co-selfcheck-checkout/co-selfcheck-checkout.module.ts